import React, { useEffect, useState } from 'react';
import './Dashstats.css';
import { Link } from 'react-router-dom';

function Dashstats() {

    const [allpro, setAllpro] = useState([]);
    const [allforord, setAllforord] = useState([]);
    const [allwebs, setAllwebs] = useState([]);
    const [allorders, setAllorders] = useState([]);
    const [ordercount, setOrdercount] = useState(0);
    const [allorderpros, setAllorderpros] = useState([]);
    const [totalsale, setTotalsale] = useState(0);
    const [estimatesale, setEstimatesale] = useState(0);
    const [mostobj, setMostobj] = useState({});
    const [allprowithnum, setAllprowithnum] = useState([]);
    const [prodata, setProdata] = useState([]);

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/`).then(res => res.json()).then(data => {
            if (data.success) setAllpro(data.pro);
        }).catch(err => console.error('error occured while getting all the product ', err));
    }, []);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/allorders`).then(res => res.json()).then(data => {
            if (data.success) setAllorders(data.pro);
        }).catch(err => console.error('error occured while getting all the orders ', err));
    }, []);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/ordercount`).then(res => res.json()).then(data => {
            if (data.success) setOrdercount(data.total);
        }).catch(err => console.error('error occured while getting all the orders ', err));
    }, []);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/leads`).then(res => res.json()).then(data => {
            if (data.success) setAllwebs(data.pro);
        }).catch(err => console.error("error occured while getting all the leads ", err));
    }, []);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/fororders`).then(res => res.json()).then(data => {
            if (data.success) setAllforord(data.pro);
        }).catch(err => console.error('error occured while getting all the product ', err));
    }, []);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/salereport`).then(res => res.json()).then(data => {
            if (data.success) {
                setTotalsale(data.totalSales);
                setEstimatesale(data.estimateSales);
            }
        }).catch(err => console.error('error occured while getting sale report ', err));
    }, []);

    useEffect(() => {
        const allids = allforord?.map(pro => pro.productid);
        const someArr = [];
        allorders?.forEach(ord => {
            const something = ord?.products.flatMap(product =>
                Array(product.quantity).fill(product.proid)
            );
            someArr.push(...something);
        });
        allids.push(...someArr);
        setAllprowithnum([...someArr]);
        const frequencymap = {};
        let maxcount = 0;
        let mostfrequentmap = null;
        allids.forEach(pro => {
            frequencymap[pro] = (frequencymap[pro] || 0) + 1;
            if (frequencymap[pro] > maxcount) {
                maxcount = frequencymap[pro];
                mostfrequentmap = pro;
            }
        });
        setMostobj(frequencymap);
    }, [allforord, allwebs, allorders]);

    useEffect(() => {
        if (allprowithnum && allprowithnum?.length > 0) {
            const ordpros = [];
            allprowithnum?.forEach(id => {
                allpro?.forEach(pro => {
                    if (id === pro.proid) ordpros.push(pro);
                });
            });
            setAllorderpros(ordpros);
        }
    }, [allprowithnum, allpro]);

    useEffect(() => {
        if (allorderpros && allorderpros?.length > 0) {
            let pricecount = 0;
            allorderpros.forEach(pro => { pricecount += pro.discountprice; });
            setTotalsale(pricecount);
        }
    }, [allorderpros]);

    useEffect(() => {
        fetch(`https://pentadeco.in/api/bestsellers`).then(res => res.json()).then(data => {
            if (data.success) setProdata(data.products);
        }).catch(err => console.error('error occured while getting bestsellers ', err));
    }, []);

    const stats = [
        { label: 'PRODUCTS',       val: allpro?.length,  icon: 'fas fa-box',           color: 'blue',   to: 'products' },
        { label: 'ORDERS',         val: ordercount,       icon: 'fas fa-clipboard-check', color: 'orange', to: 'orders' },
        { label: 'EST. SALES',     val: `₹${estimatesale}`, icon: 'fas fa-chart-line',  color: 'green',  to: null },
        { label: 'ACTUAL SALES',   val: `₹${totalsale}`, icon: 'fas fa-rupee-sign',    color: 'purple', to: null },
    ];

    return (
        <div className='main-dashstats'>
            <h2 className="body-font-bold fs-4 mt-3 mb-4">Dashboard</h2>

            {/* Stat cards */}
            <div className="row g-3 mb-5">
                {stats.map((s, i) => {
                    const inner = (
                        <div className="dash-stat-card">
                            <div className={`dash-stat-icon ${s.color}`}>
                                <i className={s.icon}></i>
                            </div>
                            <div>
                                <div className="dash-stat-val">{s.val ?? '—'}</div>
                                <div className="dash-stat-label">{s.label}</div>
                            </div>
                        </div>
                    );
                    return (
                        <div key={i} className="col-6 col-md-3">
                            {s.to
                                ? <Link to={s.to} className="nav-link p-0">{inner}</Link>
                                : inner
                            }
                        </div>
                    );
                })}
            </div>

            {/* Top products */}
            <div className="top-pros-wrap">
                <p className="dash-section-title">Top Selling Products</p>
                {prodata?.length === 0 && (
                    <p className="text-muted fs-sm">No data yet</p>
                )}
                {prodata?.map((pro, ind) => (
                    <Link
                        to={`/${pro.proid}/${pro.name.toLowerCase().replaceAll(" ", "-")}`}
                        key={ind}
                        className="dash-top-pro-card"
                    >
                        <span className="dash-top-pro-rank">#{ind + 1}</span>
                        <img src={pro.images[0]} alt={pro.name} className="dash-top-pro-img" />
                        <div className="flex-1" style={{minWidth: 0}}>
                            <div className="dash-top-pro-id">{pro.proid}</div>
                            <div className="dash-top-pro-name text-truncate">{pro.name}</div>
                            <div className="dash-top-pro-price">₹{pro.discountprice}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default Dashstats;
